import { render, staticRenderFns } from "./PsPatientDetailPersonal.vue?vue&type=template&id=07233759&scoped=true&"
import script from "./PsPatientDetailPersonal.vue?vue&type=script&lang=js&"
export * from "./PsPatientDetailPersonal.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientDetailPersonal.vue?vue&type=style&index=0&id=07233759&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07233759",
  null
  
)

export default component.exports